<template>
    <ul class="footer-social-links d-flex justify-content-center" v-if="mediaData.length">
        <li v-for="(item, indx) of mediaData" :key="indx">
            <a :href="item.media_url" v-html="item.media_icon" target="_blank"></a>
        </li>
    </ul>
</template>

<script>
export default {
    data(){
        return {
            mediaData: []
        }
    },
    methods: {        
        getSocialMedia(){
            this.$store.dispatch('getSocialMedia').then(res=>{
                this.mediaData = res.data
            })
        }
    },
    created() {
        this.getSocialMedia()
    }
}
</script>